import i18n from '@/bundles/Localization';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';

export enum FilterReferralSendTypeEnum {
  inbound = 'inbound',
  all = 'all',
  outbound = 'outbound',
}

export const FilterReferralSendTypeLabels = {
  [FilterReferralSendTypeEnum.inbound]: i18n.t(LocalizationEnum.receiving),
  [FilterReferralSendTypeEnum.all]: 'All',
  [FilterReferralSendTypeEnum.outbound]: i18n.t(LocalizationEnum.referring),
};

export const FilterReferralSendTypeItems = [
  {
    text: FilterReferralSendTypeLabels[FilterReferralSendTypeEnum.inbound],
    value: FilterReferralSendTypeEnum.inbound,
  },
  {
    text: FilterReferralSendTypeLabels[FilterReferralSendTypeEnum.all],
    value: FilterReferralSendTypeEnum.all,
  },
  {
    text: FilterReferralSendTypeLabels[FilterReferralSendTypeEnum.outbound],
    value: FilterReferralSendTypeEnum.outbound,
  },
];
